import React from "react";
import BackIcon from "../../Assets/Icons/BackIcon";
import "./style.css";
import Track1 from "../../Assets/Images/t1.png";
import Track2 from "../../Assets/Images/t2.png";
import Track3 from "../../Assets/Images/t3.png";
import Track4 from "../../Assets/Images/new/ss.png";
import Track5 from "../../Assets/Images/Track5.png";
import Track6 from "../../Assets/Images/Track6.png";
import Track7 from "../../Assets/Images/Track7.png";
import Track8 from "../../Assets/Images/Track8.png";
import stock_photo from "../../Assets/Images/stock_photo.png";
import track_and_field_banner_image from "../../Assets/Images/tes_bg.png";
import trackMobile from "../../Assets/Images/track-field-why.png";
import soccer_banner_image2 from "../../Assets/Images/soccer_banner_image2.png";
import Testimonial from "../../Components/Testimonial";
import Features from "../../Components/Features";
import soccerSkill1 from "../../Assets/Images/run1.png";
import soccerSkill2 from "../../Assets/Images/run2.png";
import soccerSkill3 from "../../Assets/Images/run3.png";
import soccerSkill4 from "../../Assets/Images/run4.png";
import soccerSkill5 from "../../Assets/Images/run5.png";
import dribbling from "../../Assets/Images/dribbling.png";
import shooting from "../../Assets/Images/shooting.png";
import passing from "../../Assets/Images/passing.png";
import defense from "../../Assets/Images/defense.png";
import rebounding from "../../Assets/Images/rebounding.png";
import SprintIcon from "../../Assets/Icons/SprintIcon";
import ACIcon from "../../Assets/Icons/ACIcon";
import ECIcon from "../../Assets/Icons/ECIcon";
import soccer_trainer1 from "../../Assets/Images/basketball_trainer1.png";
import soccer_trainer2 from "../../Assets/Images/basketball_trainer2.png";
import soccer_trainer3 from "../../Assets/Images/basketball_trainer3.png";

import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

export default function TrackAndField() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleSubmit = (type) => {
    if (user && user.is_self_pay === false && type) {
      navigate(`/list-of-sports?type=${type}`);
    } else if (user && user.is_self_pay === true && type) {
      navigate(`/session-sports?type=${type}`);
    } else {
      navigate(`/create-an-account`);
    }
  };
  // const featuresData = {
  //     color: 'red',
  //     Icon1: SprintIcon,
  //     Icon2: ACIcon,
  //     Icon3: ECIcon
  // }
  return (
    <>
      <SEO
        title="Instruction | Track & Field | BWC Sports"
        description=""
        url="https://bwcsports.com/instruction/track-and-field"
      />
      <div className="track-and-field-container">
        <div className="track-and-field-header filter-brightness">
          <div className="base-sec">
            <div>
              <span className="track-and-field-backIcon">
                <BackIcon />
              </span>
            </div>
            <div className="track-and-field-header-content">
              <h1
                className="black-text-clip"
                style={{ "--clip-color": "#850000" }}
              >
                Track & Field
              </h1>
              <h3 className="black-text-clip">
                Ignite Your Speed and Endurance with BWC Track & Field!
              </h3>
              <h5 className="black-text-clip">
                Train Like a Champion with Staten Island’s Elite Track & Field
                Program
              </h5>
              <p className="black-text-clip">
                Whether your child is looking to sprint faster, jump higher, or
                improve their endurance, BWC Track & Field offers expert
                training designed to take young athletes to the next level. With
                world-className instruction and a supportive, fun environment,
                BWC Track & Field is the perfect place to kickstart your child’s
                journey into the world of track and field.
              </p>
            </div>
          </div>
        </div>
        <div className="track-and-field-booking-container">
          <button
            className="one-on-one"
            onClick={() => handleSubmit("1-1")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            onClick={() => handleSubmit("Group")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one track-and-field-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer" }}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>
        <div className="track-and-field-image-container">
          <img src={Track1} alt="soccer-image" />
          <img src={Track2} alt="soccer-image" />
          <img src={Track3} alt="soccer-image" />
          <img src={Track4} alt="soccer-image" />
        </div>
        <div className="track-and-field-section2">
          <h3 className="black-text-clip">Why Choose BWC Track & Field?</h3>
          <p className="black-text-clip">
            At BWC Track & Field, we believe in creating a fun and competitive
            atmosphere where athletes of all ages and abilities can grow. Our
            program caters to kids from 4 to 18 years old, offering a wide range
            of training options that cover every aspect of track and field.
          </p>
          <div className="track-and-field-section2-image-container">
            <span
              className="track-and-field-overlay-text bottom-left t-left"
              style={{ color: "white", fontSize: "clamp(12px, 3vw, 22px)" }}
            >
              1-on-1 Training
            </span>
            <span
              className="track-and-field-overlay-text bottom-right t-right"
              style={{ color: "white", fontSize: "clamp(12px, 3vw, 22px)" }}
            >
              Skill Specific Drills
            </span>
            <span
              className="track-and-field-overlay-text bottom-middle t-center"
              style={{ color: "white", fontSize: "clamp(12px, 3vw, 22px)" }}
            >
              Group Clinics
            </span>
            <img
              className="track-why-desktop"
              src={track_and_field_banner_image}
              alt="soccer-image-session"
            />
            <img
              className="track-why-mobile"
              src={trackMobile}
              alt="track-mobile"
            />
          </div>
        </div>

        <div className="track-and-field-section3">
          <h3 className="black-text-clip">Programs That Make Champions</h3>
          <p className="black-text-clip">
            Our training programs are designed to cover all key aspects of track
            and field, ensuring that each athlete develops the skills needed for
            success:
          </p>
          <div className="soccer-section3-image-container">
            <div className="sc-card">
              <img src={soccerSkill1} alt="Sprinting" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Sprinting</div>
                <div className="sc-card-desc">
                  Master your speed with acceleration, stride optimization, and
                  finish-line techniques.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={soccerSkill2} alt="Distance Running" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Distance Running</div>
                <div className="sc-card-desc">
                  Build endurance, pace control, and mental toughness for those
                  long runs.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={soccerSkill3} alt="Jumping" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Jumping</div>
                <div className="sc-card-desc">
                  Perfect your long and high jump form with technique-focused
                  sessions.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={soccerSkill5} alt="Throwing" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Throwing</div>
                <div className="sc-card-desc">
                  Learn the essentials of shot put, javelin, and discus for
                  powerful, accurate throws.
                </div>
              </div>
            </div>

            <div className="sc-card">
              <img src={soccerSkill4} alt="Agility & Speed" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Agility & Speed</div>
                <div className="sc-card-desc">
                  Improve quickness and reaction time, crucial for success in
                  any track event.
                </div>
              </div>
            </div>

            {/* <div className="soccer_section_image_cont"><span className="skill-text-overlay">Passing</span><img src={soccerSkill1} alt="Shooting" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Shooting</span><img src={soccerSkill2} alt="Passing" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Defending</span><img src={soccerSkill3} alt="Defense" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Goal Keeping</span><img src={soccerSkill4} alt="Rebounding" /></div> */}
          </div>
        </div>
        <div className="track-and-field-section4">
          <h3 className="black-text-clip">Fun and Competitive Games</h3>
          <p className="black-text-clip">
            Our track & field program isn’t just about drills and technique—it’s
            about having fun while competing. We incorporate exciting challenges
            and games like:
          </p>
        </div>
        <Features
          color="red"
          Icon1={SprintIcon}
          Icon2={ECIcon}
          Icon3={ACIcon}
        />
        <div className="track-and-field-section4">
          <h3 className="black-text-clip">Scrimmages and Track Meets</h3>
          <p className="black-text-clip">
            No training is complete without the thrill of competition. Our
            scrimmages and track meets give athletes the chance to apply what
            they’ve learned in a real-world setting. These events help build
            confidence, camaraderie, and the competitive spirit needed for
            success in track and field.
          </p>
        </div>
        <div className="testimonial-container">
          <h3 className="testimonial-header black-text-clip">
            WHAT PARENTS ARE SAYING
          </h3>
        </div>
        <Testimonial />

        <div className="track-and-field-booking-container2">
          <div className="track-and-field-booking-container-details">
            <h3>Ready to Get on Track?</h3>
            <p>
              If you want your child to experience the joy and excitement of
              track & field, BWC Track & Field is the perfect place to start.
              With Carlos Pineiro leading the charge, we provide a supportive,
              high-energy environment where young athletes can thrive. Spots are
              limited, so don’t miss out!
            </p>
            <p>
              <strong>Sign Up Now</strong> – Help your child reach new heights
              in track & field!
            </p>
          </div>
          <div className="track-and-field-booking-container inside-booking-container">
            <button
              className="one-on-one"
              onClick={() => handleSubmit("1-1")}
              style={{ cursor: "pointer" }}
            >
              <span className="black-text-clip">
                Schedule 1-on-1 Class Here
              </span>
            </button>
            <button
              className="one-on-one"
              onClick={() => handleSubmit("Group")}
              style={{ cursor: "pointer" }}
            >
              <span className="black-text-clip">Schedule Group Class Here</span>
            </button>
            {!user && (
              <button
                className="one-on-one track-and-field-booking-selected"
                onClick={() => handleSubmit("")}
                style={{ cursor: "pointer" }}
              >
                Sign Up for Classes Here
              </button>
            )}
          </div>
        </div>
        <div className="track-and-field-booking-container outside-booking-container">
          <button
            className="one-on-one"
            onClick={() => handleSubmit("1-1")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            onClick={() => handleSubmit("Group")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one track-and-field-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer" }}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>

        {/* <div className="track-and-field-trainers">
                    <h3>Our Trainers</h3>
                    <div className="track-and-field-trainer-image-container">
                        <div className="track-and-field-trainer-image">
                            <div className="skill-text-overlay">
                                <h4>Trainer Name</h4>
                                <p>Trainer Specification</p>
                            </div>
                            <img src={soccer_trainer1} alt="trainer-image" />

                        </div>
                        <div className="track-and-field-trainer-image">
                            <div className="skill-text-overlay">
                                <h4>Trainer Name</h4>
                                <p>Trainer Specification</p>
                            </div>
                            <img src={soccer_trainer2} alt="trainer-image" />

                        </div>
                        <div className="track-and-field-trainer-image">
                            <div className="skill-text-overlay">
                                <h4>Trainer Name</h4>
                                <p>Trainer Specification</p>
                            </div>
                            <img src={soccer_trainer3} alt="trainer-image" />

                        </div>
                    </div>
                </div> */}

        <div className="track-and-field-section4">
          <h3 className="black-text-clip">Why This Program Stands Out</h3>
          <p className="black-text-clip">
            We’ve created a program that not only focuses on skill development
            but also fosters a love for the sport. Whether your child is a
            sprinter, distance runner, or budding field event star, our
            personalized approach ensures they have the tools they need to
            succeed.
          </p>
        </div>
        <div className="track-and-field-locations">
          <h3 className="black-text-clip text-center">Locations</h3>
          <div className="track-and-field-location-container">
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24228.92735189222!2d-74.14155600000001!3d40.61629700000001!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24c3387658829%3A0x770465e3707ce954!2sChurch%20of%20the%20Holy%20Family%2C%20366%20Watchogue%20Rd%2C%20Staten%20Island%2C%20NY%2010314!5e0!3m2!1sen!2sus!4v1773672383043!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Holy Family</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24226.505733105198!2d-74.144522!3d40.622974!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24dcbb35168c3%3A0xcd6f473a667d96ab!2s80%20Willowbrook%20Rd%2C%20Staten%20Island%2C%20NY%2010302!5e0!3m2!1sen!2sus!4v1773672421909!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>I.S. 51</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24258.30795685743!2d-74.239816!3d40.535215!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b53f9530b093%3A0x923a08def777405b!2s120%20Androvette%20St%2C%20Staten%20Island%2C%20NY%2010309!5e0!3m2!1sen!2sus!4v1773672482912!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>JUMPSHOTZ</strong>, New York
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
